import http from "../../utils/http"
/**
 * 获取已登录账户的分仓列表
 */
export function getWarehouseList(params) {
    return http({
        url: "/api/warehouse/warehouseMemberLists",
        data: params,
        forceLogin: true
    })
}